import { styled } from '@tools/wr-catalog-base'

export const OptionWrapper = styled.div`
  padding: 8px 0;

  ${({ isSelected }) =>
    isSelected &&
    `
    pointer-events: none;
    cursor: default;
  `};

  padding-left: ${({ paddingLeft }) => paddingLeft || '20px'};

  label {
    ${({ theme, isSelected }) =>
      isSelected &&
      `
      color: ${theme.components.dropdownInput.selectedColor}
      cursor: default;
    `};
  }
`
